<template>
  <app-layout>
     <template v-slot:headerTitle>
         <p>Application Settings</p>
    </template>
     <template v-slot:tallystatus>
          <div  v-show="tally_open_status=='false'">
                <i class="fa fa-times refresh" aria-hidden="true" ></i>
          </div>
           <div  v-show="tally_open_status=='true'">
                <i class="fas fa-check refresh" aria-hidden="true" ></i>
          </div>
     </template>
     <template v-slot:headerNav>
             <jet-nav-link
                 class="ml-11"
                :href="route('integrates.index')"
                :active="route().current('integrates.index')"
              >
                Integrate
              </jet-nav-link>
              <jet-nav-link
                 class="ml-11"
                :href="route('templates.index')"
                :active="route().current('templates.index')"
              >
                Template
              </jet-nav-link>
              <jet-nav-link
              class="ml-11"
                :href="route('configurations.index')"
                :active="route().current('configurations.index')"
              >
                Settings
              </jet-nav-link>
     </template>  
    <!-- <PageTitle :headerTitle="title"> </PageTitle> -->
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-2 edit_view pt-4">
          <div class="w-full">
            <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 ">
              <!-- <div class="text-lg font-bold ">Create {{moduleName}}</div> -->
                    <DxForm :form-data="form_data" @field-data-changed="drop_down_change">
                            <DxSimpleItem
                                    data-field="ip_address"
                            />
                            <DxSimpleItem
                                    data-field="port_no"
                            />
                            <DxSimpleItem
                                    data-field="License_no"
                            />
                     </DxForm>
                      <div class="panel-footer mt-2">
                        <a :href="'/'+moduleRoute" class="btn-close text-blue-500  border rounded text-sm pl-2 pr-2 pt-1 pb-1 hover:no-underline"> Back</a> &nbsp;&nbsp;
                        <jet-button type="submit" @click="update" class="bg-blue-500 rounded text-sm pl-2 pr-2 pt-1 pb-1 text-white hover:no-underline"> Update </jet-button>
                      </div>
                      <DxToast
                        v-model:visible="isVisible"
                        v-model:message="messag"
                        v-model:type="type"
                      />
        </div>
      </div>
    </div>
  </app-layout>
</template>
<script>  
import JetNavLink from '@/Jetstream/NavLink.vue';
import AppLayout from '@include/pages/BaseLayouts/tallyClinicAppLayout.vue';
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import DxTextBox from 'devextreme-vue/text-box';
import {getConfigurationCredentials,save_user_credentials} from './js/configuration.js';
import {isElectron} from "@include/pages/modules/UtilsJs/utils.js";
import {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
} from 'devextreme-vue/form';
const modelData = {};
export default {
  props: {
    createDef: Array,
    moduleRoute: String,
    moduleName:  String,
    modelData:{
        type: Object,
        default: () => ({})
    },
  },
  components: {
    AppLayout,
    BsEdit,
    PageTitle,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxTextBox,
    JetNavLink
  },
  data: function () {
    return {
      form_data:{"ip_address":"","port_no":"","License_no":""},
      title:this.moduleRoute+" Create",
      isVisible: false,
      messag: '',
      type: 'info',
      metas:'',
    };
  },
  methods: {
    checkAction()
    {
      return (this.modelData.hasOwnProperty("id") && this.modelData.id != "")
    },
    update()
    {
              save_user_credentials(this.form_data);
              //save_user_credentials(this.$refs.formRenderer.formData);
              // this.$inertia.put(route(this.moduleRoute+'.update',this.modelData.id),this.$refs.formRenderer.formData)
    },
    submit() {
              // console.log(this.$refs.formRenderer.formData)                
              // this.$inertia.post('/'+this.moduleRoute, this.$refs.formRenderer.formData)
    },
  },
  mounted() {
  console.log("createDef");
  console.log(this.createDef);
   var _this=this;
    if(isElectron()){
              this.messag = this.message;
              this.is_electron = true;
              this.metas = "electron";
              window.api.send('checkTallyOpening'); 
              window.api.receive("checkTallyOpening-reply", (tally_response) => {
                    if(tally_response == "tally is not open"){
                          this.tally_is_open = false;
                          this.messag = tally_response;
                          this.isVisible = true;
                    }
                    else if(tally_response == "tally is open"){
                          this.tally_is_open = true;
                          getConfigurationCredentials(_this,this.metas,this.license_no);
                    }
              });
          }
          else{
              this.is_electron = false;
              this.messag = this.message;
              if(this.messag == "You Dont have a valid license number for this service"){
                this.isVisible = true; 
              }
              axios.post('/checkTallyIsOpen')
                .then((result) => {
                    if(result.data!="not_open"){
                          this.tally_is_open = true;
                    }
                    else{
                          this.tally_is_open = false;
                          this.messag = "tally is not open";
                          this.isVisible = true;
                    }
                })
          }
  },
};
</script>
<style>
.edit_view{
height: 84vh;
}
</style>